import { JSX } from 'react'

import { IconProps } from '../../icon'

const Success: (props: IconProps) => JSX.Element = ({
  dataTestId,
  fill,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill={fill}
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24 10.7429C16.6783 10.7429 10.7429 16.6783 10.7429 24C10.7429 31.3218 16.6783 37.2571 24 37.2571C31.3218 37.2571 37.2571 31.3218 37.2571 24C37.2571 16.6783 31.3218 10.7429 24 10.7429ZM8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24ZM31.004 19.0074C31.5396 19.543 31.5396 20.4112 31.004 20.9468L22.9583 28.9925C22.4227 29.5281 21.5545 29.5281 21.0189 28.9925L17.1788 25.1525C16.6433 24.617 16.6433 23.7488 17.1788 23.2132C17.7144 22.6776 18.5827 22.6776 19.1183 23.2132L21.9886 26.0833L29.0646 19.0074C29.6002 18.4718 30.4684 18.4718 31.004 19.0074Z'
      fill={fill}
    />
  </svg>
)

export default Success
